import { CaseStyle } from "kryo";
import { LiteralType } from "kryo/literal";
import { RecordIoType, RecordType } from "kryo/record";

import { $ActorType, ActorType} from "../types/user/actor-type.mjs";
import { $AuthScope, AuthScope } from "./auth-scope.mjs";

export interface GuestAuthContext {
  type: ActorType.Guest;
  scope: AuthScope;
}

export const $GuestAuthContext: RecordIoType<GuestAuthContext> = new RecordType<GuestAuthContext>({
  properties: {
    type: {type: new LiteralType({type: $ActorType, value: ActorType.Guest})},
    scope: {type: $AuthScope},
  },
  changeCase: CaseStyle.SnakeCase,
});

export const GUEST_AUTH: GuestAuthContext = Object.freeze({type: ActorType.Guest, scope: AuthScope.Default});
